module.exports = __webpack_public_path__ + "static/media/arrow-light.b36b2164.svg";